






















import { defineComponent, PropType, ref, toRefs } from '~/utils/nuxt3-migration'
import { ciTimes } from '~/icons/source/solid/times'
import { ButtonSize, ButtonVariant } from '~/models/app/button'
import ReceiptOrInvoiceModal from '~/components/shared/account/payments/subscriptions/ReceiptOrInvoiceModal.vue'

export default defineComponent({
  components: { ReceiptOrInvoiceModal },
  props: {
    auditRequestId: {
      type: Number,
      required: true
    },
    paymentUrl: {
      type: String,
      required: true
    },
    actionText: {
      type: String,
      required: false,
      default: ''
    },
    confirmText: {
      type: String,
      required: false,
      default: ''
    },
    size: {
      type: String as PropType<ButtonSize>,
      default: 'sm'
    },
    variant: {
      type: String as PropType<ButtonVariant>,
      default: 'secondary'
    },
    outline: { type: Boolean, default: false },
    buttonClass: {
      type: [Object, String, Array],
      required: false,
      default: 'tw-w-full'
    },
    icon: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  setup(props, { emit }) {
    const { paymentUrl } = toRefs(props)
    const showReceiptModal = ref(false)

    const onReceiptModalBuy = () => {
      if (paymentUrl.value) {
        setTimeout(() => {
          window.location.href = paymentUrl.value
        }, 1000)
      }

      emit('invoice-complete')
    }

    return {
      ciTimes,
      showReceiptModal,
      onReceiptModalBuy
    }
  }
})
